
import React from 'react';
import './Divider.scss';

export default ({ children }) => (
  <div className="Divider">{ children }</div>
);

